import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreateMessageRoutingModule } from './create-message-routing.module';
import { MakesListComponent } from './makes-list/makes-list.component';
import { SharedModule } from '../../common/shared/shared.module';
import { FloatingFooterComponent } from './floating-footer/floating-footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChooseDocumentsComponent } from './choose-documents/choose-documents.component';
import { SendMessageAddressSelectComponent } from './send-message-address-select/send-message-address-select.component'
import { SendMessageComponent } from './send-message/send-message.component';

const declarations = [
    MakesListComponent
];

@NgModule({
    declarations: [
        ...declarations,
        FloatingFooterComponent,
        ChooseDocumentsComponent,
        SendMessageComponent,
        SendMessageAddressSelectComponent,
    ],
    imports: [
        CommonModule,
        CreateMessageRoutingModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class CreateMessageModule { }
